import { __decorate } from "tslib";
import { Vue, Component, Mixins, Ref } from "vue-property-decorator";
import NavbarApp from "@/components/NavbarApp.vue";
import NavbarStickyMobile from "@/components/NavbarStickyMobile.vue";
import FooterApp from "@/components/FooterApp.vue";
import ScreenIntro from "@/screens/ScreenIntro.vue";
import ScreenIntroAdv from "@/screens/ScreenIntroAdv.vue";
import ScreenSkills from "@/screens/ScreenSkills.vue";
import ScreenCatalogue from "@/screens/ScreenCatalogue.vue";
import ScreenAdv from "@/screens/ScreenAdv.vue";
import ScreenSchedule from "@/screens/ScreenSchedule.vue";
import ScreenReviews from "@/screens/ScreenReviews.vue";
import ScreenPrice from "@/screens/ScreenPrice.vue";
import FormCall from "@/components/FormCall.vue";
import FormPay from "@/components/FormPay.vue";
import GalleryMain from "./components/GalleryMain.vue";
import LoaderApp from "@/components/LoaderApp.vue";
import { uiMapper } from "@/services/store/modules/ui/store";
import device from "current-device";
import scrollTo from "@/mixins/scrollTo";
import animateIfVisible from "./mixins/animateIfVisible";
import { dataMapper } from "./services/store/modules/data/store";
import sleep from "@/mixins/sleep";
import { VisibilityObserver, } from "./mixins/VisibilityObserver";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["formCallIsShown", "breakpoint", "formPayIsShown"]),
    },
    methods: {
        ...uiMapper.mapMutations([
            "closeFormCall",
            "openFormCall",
            "setBreakpoint",
            "setWindowWidth",
            "setCurrentDevice",
        ]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["courses"]),
    },
    methods: {
        ...dataMapper.mapActions(["loadData"]),
    },
});
const grid = require("@/styles/grid-config.json");
let App = class App extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.globalLoaderIsShown = true;
        this.scrollKeys = { 37: 1, 38: 1, 39: 1, 40: 1 };
        this.scrollToOffset = {
            pros: -120,
            inst: 120,
            catalogue: -75,
            "trial-lesson": 100,
        };
        this.scrollToOffsetMob = {
            pros: -50,
            inst: 50,
            catalogue: -25,
            "trial-lesson": 0,
        };
        this.navbarObserver = null;
        this.stickyNavbarShown = false;
        this.sliderImgsVert = [
            "/static/images/gallery/malina-vert-22.jpeg",
            "/static/images/gallery/malina-vert-2.jpeg",
            "/static/images/gallery/malina-vert-3.jpeg",
            "/static/images/gallery/malina-vert-25.jpeg",
            "/static/images/gallery/malina-vert-26.jpg",
            "/static/images/gallery/malina-vert-28.jpeg",
            "/static/images/gallery/malina-vert-9.jpeg",
            "/static/images/gallery/malina-vert-6.jpeg",
            "/static/images/gallery/malina-vert-1.jpeg",
            "/static/images/gallery/malina-vert-12.jpeg",
            "/static/images/gallery/malina-vert-13.jpeg",
            "/static/images/gallery/malina-vert-16.jpeg",
            "/static/images/gallery/malina-vert-18.jpeg",
            "/static/images/gallery/malina-vert-20.jpeg",
            "/static/images/gallery/malina-vert-23.jpeg",
        ];
        this.sliderImgsHoriz = [
            "/static/images/gallery/malina-horiz-8.jpeg",
            "/static/images/gallery/malina-horiz-1.jpeg",
            "/static/images/gallery/malina-horiz-5.jpeg",
            "/static/images/gallery/malina-horiz-6.jpeg",
            "/static/images/gallery/malina-horiz-2.jpeg",
            "/static/images/gallery/malina-horiz-3.jpeg",
            "/static/images/gallery/malina-horiz-4.jpeg",
            "/static/images/gallery/malina-horiz-7.jpeg",
            "/static/images/gallery/food-1.jpg",
        ];
    }
    get isLtMd() {
        return this.breakpoint === "xs" || this.breakpoint === "sm";
    }
    get isXs() {
        return this.breakpoint === "xs";
    }
    get isPageCourse() {
        return this.$route.name === "PageCourse";
    }
    async created() {
        this.loadData();
        this.disableScroll();
        document.addEventListener("keydown", this.keydownHandler);
        this.setCurrentDevice(device);
        window.addEventListener("resize", () => this.windowResizeHandler(grid, window.innerWidth));
        this.windowResizeHandler(grid, window.innerWidth);
        const hash = this.$route.hash;
        if (hash) {
            await sleep(1000);
            const offset = this.isLtMd
                ? this.scrollToOffsetMob[hash.slice(1)]
                : this.scrollToOffset[hash.slice(1)];
            scrollTo(hash, offset, 100, async () => {
                await this.$nextTick();
                this.enableScroll();
                this.globalLoaderIsShown = false;
            });
        }
        else {
            await sleep(1000);
            this.enableScroll();
            this.globalLoaderIsShown = false;
        }
        await this.$nextTick;
        animateIfVisible();
        this.checkNavbarVisibility();
    }
    beforeDestroy() {
        document.body.classList.remove("modal-open");
        document.removeEventListener("keydown", this.keydownHandler);
    }
    keydownHandler(evt) {
        if (evt.key === "Escape" && this.formCallIsShown)
            this.closeFormCall();
    }
    async windowResizeHandler(grid, windowWidth) {
        this.setWindowWidth(windowWidth);
        if (!grid)
            return;
        const queriesAll = Object.entries(grid.queries);
        const queriesCurrent = queriesAll.filter((query) => window.matchMedia(query[1]).matches);
        const breakpoint = queriesCurrent.find((rule) => rule[0].length === 2)[0];
        this.setBreakpoint(breakpoint);
        await this.$nextTick;
        animateIfVisible();
    }
    // disable scroll methods
    preventDefault(e) {
        e.preventDefault();
    }
    preventDefaultForScrollKeys(e) {
        if (this.scrollKeys[e.keyCode]) {
            this.preventDefault(e);
            return false;
        }
    }
    disableScroll() {
        // modern Chrome requires { passive: false } when adding event
        let supportsPassive = null;
        try {
            window.addEventListener("test", null, Object.defineProperty({}, "passive", {
                get: () => {
                    supportsPassive = true;
                },
            }));
        }
        catch (e) { }
        const wheelOpt = supportsPassive ? { passive: false } : false;
        const wheelEvent = "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";
        window.addEventListener("DOMMouseScroll", this.preventDefault, false); // older FF
        window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
        window.addEventListener("touchmove", this.preventDefault, wheelOpt); // mobile
        window.addEventListener("keydown", this.preventDefaultForScrollKeys, false);
    }
    enableScroll() {
        const wheelEvent = "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";
        window.removeEventListener("DOMMouseScroll", this.preventDefault, false);
        window.removeEventListener(wheelEvent, this.preventDefault);
        window.removeEventListener("touchmove", this.preventDefault);
        window.removeEventListener("keydown", this.preventDefaultForScrollKeys, false);
    }
    checkNavbarVisibility() {
        const target = this.navbarRef.$el;
        const options = {
            targets: target,
            offset: 0,
            ifIntoView: () => (this.stickyNavbarShown = false),
            ifOutOfView: () => (this.stickyNavbarShown = true),
        };
        this.navbarObserver = new VisibilityObserver(options);
    }
};
__decorate([
    Ref()
], App.prototype, "navbarRef", void 0);
App = __decorate([
    Component({
        metaInfo: {
            title: "Малина Летние программы",
        },
        components: {
            NavbarApp,
            NavbarStickyMobile,
            FooterApp,
            ScreenIntro,
            ScreenIntroAdv,
            ScreenSkills,
            ScreenCatalogue,
            ScreenAdv,
            ScreenSchedule,
            ScreenReviews,
            ScreenPrice,
            FormCall,
            LoaderApp,
            FormPay,
            GalleryMain,
        },
    })
], App);
export default App;
